(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  function pndUpdateAnnounceCountdown() {
    var el = document.getElementById('announceCountdown');
    if (!el) return;
    var target = new Date(el.dataset.dropDatetime);
    if (isNaN(target.getTime())) return;
    var diff = Math.max(0, target - new Date());
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    var mins = Math.floor((diff / (1000 * 60)) % 60);
    el.textContent = days + 'j ' + hours + 'h ' + mins + 'm';
  }
  pndUpdateAnnounceCountdown();
  setInterval(pndUpdateAnnounceCountdown, 30000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["badges-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setBadges(count) {
      var grid = document.getElementById('badges-grid');
      grid.querySelectorAll('[data-badge-slot]').forEach(function (slot) {
        var idx = parseInt(slot.getAttribute('data-badge-slot'), 10);
        if (idx <= count) slot.setAttribute('data-filled', idx);
        else slot.removeAttribute('data-filled');
      });
      document.getElementById('badges-count').textContent = count;
      document.getElementById('badges-bar-fill').style.width = Math.min(100, (count / 8) * 100) + '%';
      document.getElementById('badges-progress').hidden = false;
    }

    function storedRewardFor(email) {
      try {
        var saved = JSON.parse(localStorage.getItem('pnd_badge_reward') || 'null');
        if (saved && saved.code && saved.email === email.toLowerCase()) return saved.code;
      } catch (e) {}
      return null;
    }

    function showReward(hasReward, email) {
      var box = document.getElementById('badges-reward');
      if (!hasReward) { box.hidden = true; return; }
      var code = storedRewardFor(email);
      document.getElementById('badges-reward-code-text').textContent = code || '—';
      document.getElementById('badges-reward-with-code').hidden = !code;
      document.getElementById('badges-reward-no-code').hidden = !!code;
      box.hidden = false;
    }

    document.getElementById('badges-check').addEventListener('click', function () {
      var email = document.getElementById('badges-email').value.trim();
      var errorEl = document.getElementById('badges-error');
      errorEl.hidden = true;
      if (!email) return;
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Recherche…';
      fetch('https://pnd-espace-pro-api.hugoa66000.workers.dev/api/public/badges?email=' + encodeURIComponent(email))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.found) {
            errorEl.hidden = false;
            document.getElementById('badges-progress').hidden = true;
            setBadges(0);
            showReward(false, email);
            return;
          }
          setBadges(data.badge_count);
          showReward(data.has_reward, email);
        })
        .catch(function () { errorEl.textContent = 'Erreur de chargement — réessaie.'; errorEl.hidden = false; })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = 'Voir ma collection';
        });
    });

    document.getElementById('badges-copy').addEventListener('click', function () {
      var code = document.getElementById('badges-reward-code-text').textContent;
      navigator.clipboard.writeText(code).then(function () {
        var btn = document.getElementById('badges-copy');
        btn.textContent = 'Copié !';
        setTimeout(function () { btn.textContent = 'Copier'; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var form = document.getElementById('FacetFiltersForm');
    if (form) {
      form.querySelectorAll('[data-facet-auto]').forEach(function (el) {
        el.addEventListener('change', function () { form.requestSubmit(); });
      });
      var resetBtn = form.querySelector('[data-reset-filters]');
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          window.location.href = window.location.pathname;
        });
      }
    }

    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    var searchInput = document.getElementById('catalogue-search');
    var clearBtn = document.getElementById('search-clear');
    var grid = document.getElementById('prod-grid');
    var noResults = document.getElementById('no-results');
    var resultCount = document.getElementById('result-count-num');
    var pagination = document.getElementById('pagination-block');

    function filterCatalogue() {
      var query = (searchInput.value || '').trim().toLowerCase();
      clearBtn.style.display = query ? 'block' : 'none';
      if (!grid) return;

      var cards = grid.querySelectorAll('[data-prod-card]');
      var visibleCount = 0;
      cards.forEach(function (card) {
        var title = (card.dataset.title || '').toLowerCase();
        var set = (card.dataset.set || '').toLowerCase();
        var type = (card.dataset.type || '').toLowerCase();
        var matches = !query || title.indexOf(query) > -1 || set.indexOf(query) > -1 || type.indexOf(query) > -1;
        card.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      if (resultCount) resultCount.textContent = visibleCount;
      if (noResults) noResults.style.display = visibleCount === 0 ? 'block' : 'none';
      grid.style.display = visibleCount === 0 ? 'none' : 'grid';
      if (pagination) pagination.style.display = (visibleCount === 0 || query) ? 'none' : 'flex';
    }

    if (searchInput) {
      searchInput.addEventListener('input', filterCatalogue);
      clearBtn.addEventListener('click', function () {
        searchInput.value = '';
        filterCatalogue();
        searchInput.focus();
      });
      var clearSearchLink = document.querySelector('[data-clear-search]');
      if (clearSearchLink) {
        clearSearchLink.addEventListener('click', function () {
          searchInput.value = '';
          filterCatalogue();
        });
      }

      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      if (q) {
        searchInput.value = q;
        filterCatalogue();
      }
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["espace-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var AUTH_HASH = '7a3d3a459c181e4c239803760f6b6d2dfd7012437c43594662da10a5c04f943b';
    var AUTH_KEY = 'pnd_espace_pro_auth';
    var AUTH_TTL = 1000 * 60 * 60 * 12;

    function sha256Hex(str) {
      var enc = new TextEncoder().encode(str);
      return crypto.subtle.digest('SHA-256', enc).then(function (buf) {
        return Array.prototype.map.call(new Uint8Array(buf), function (b) {
          return b.toString(16).padStart(2, '0');
        }).join('');
      });
    }

    function isAuthed() {
      try {
        var raw = localStorage.getItem(AUTH_KEY);
        if (!raw) return false;
        var data = JSON.parse(raw);
        return data.hash === AUTH_HASH && Date.now() < data.exp;
      } catch (e) {
        return false;
      }
    }

    function showApp() {
      document.getElementById('ep-login').hidden = true;
      document.getElementById('ep-app').hidden = false;
      switchView('dashboard');
    }

    function showLogin() {
      document.getElementById('ep-app').hidden = true;
      document.getElementById('ep-login').hidden = false;
    }

    if (isAuthed()) { showApp(); } else { showLogin(); }

    var form = document.getElementById('ep-login-form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var user = document.getElementById('ep-user').value.trim();
      var pass = document.getElementById('ep-pass').value;
      var errEl = document.getElementById('ep-login-error');
      sha256Hex(user + ':' + pass).then(function (hash) {
        if (hash === AUTH_HASH) {
          localStorage.setItem(AUTH_KEY, JSON.stringify({ hash: AUTH_HASH, exp: Date.now() + AUTH_TTL }));
          errEl.hidden = true;
          showApp();
        } else {
          errEl.hidden = false;
          document.getElementById('ep-pass').value = '';
        }
      });
    });

    var logoutBtn = document.getElementById('ep-logout');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', function () {
        localStorage.removeItem(AUTH_KEY);
        showLogin();
      });
    }

    var API_BASE = 'https://pnd-espace-pro-api.hugoa66000.workers.dev';
    var API_SECRET = '43996a2772acd70d3e8288aa24a633c205520549be6fcf1fa08d1eae7a2227d9';

    function apiFetch(path, options) {
      options = options || {};
      return fetch(API_BASE + path, {
        method: options.method || 'GET',
        headers: Object.assign({ 'Authorization': 'Bearer ' + API_SECRET, 'Content-Type': 'application/json' }, options.headers || {}),
        body: options.body ? JSON.stringify(options.body) : undefined,
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error((data && data.error) || 'request_failed');
          return data;
        });
      });
    }

    function switchView(name) {
      document.querySelectorAll('.ep-view').forEach(function (el) {
        el.hidden = el.getAttribute('data-view') !== name;
      });
      document.querySelectorAll('.ep-nav-item[data-nav]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-nav') === name);
      });
      document.getElementById('ep-app').classList.toggle('ep-fullscreen-mode', name === 'soon');
      if (name === 'dashboard') loadDashboard();
      if (name === 'orders') loadOrdersList();
      if (name === 'products') loadProductsList();
      if (name === 'stock') loadStockList();
      if (name === 'drops') loadDropSettings();
      if (name === 'discounts') loadDiscounts();
      if (name === 'email-alerts') loadEmailAlerts();
      if (name === 'customers') loadCustomers();
      if (name === 'reviews') loadReviews();
      if (name === 'soon') generateComingSoonParticles();
    }

    function generateComingSoonParticles(force) {
      var container = document.getElementById('ep-comingsoon-particles');
      if (!container) return;
      if (container.dataset.generated && !force) return;
      container.dataset.generated = 'true';
      var rise = (container.clientHeight || window.innerHeight) + 40;
      var html = '';
      for (var i = 0; i < 40; i++) {
        var color = i % 2 === 0 ? 'purple' : 'gold';
        var left = (Math.random() * 100).toFixed(1);
        var size = (4 + Math.random() * 8).toFixed(1);
        var duration = (8 + Math.random() * 10).toFixed(1);
        var delay = (-(Math.random() * 12)).toFixed(1);
        var drift = (Math.random() * 90 - 45).toFixed(0);
        html += '<span class="ep-comingsoon-particle ' + color + '" style="left:' + left + '%; width:' + size + 'px; height:' + size + 'px; animation-duration:' + duration + 's; animation-delay:' + delay + 's; --drift:' + drift + 'px; --rise:' + rise + 'px;"></span>';
      }
      container.innerHTML = html;
    }

    var comingSoonExitBtn = document.getElementById('ep-comingsoon-exit');
    if (comingSoonExitBtn) {
      comingSoonExitBtn.addEventListener('click', function () { switchView('dashboard'); });
    }

    var comingSoonMobileToggle = document.getElementById('ep-comingsoon-mobile-toggle');
    if (comingSoonMobileToggle) {
      comingSoonMobileToggle.addEventListener('click', function () {
        var stage = document.getElementById('ep-comingsoon-stage');
        var isOn = stage.classList.toggle('mobile-preview');
        comingSoonMobileToggle.setAttribute('aria-pressed', String(isOn));
        comingSoonMobileToggle.textContent = isOn ? '🖥️ Format desktop' : '📱 Format story';
        setTimeout(function () { generateComingSoonParticles(true); }, 320);
      });
    }

    var mobileNavToggle = document.getElementById('ep-mobile-nav-toggle');
    var sidebarBackdrop = document.getElementById('ep-sidebar-backdrop');
    var sidebarEl = document.getElementById('ep-sidebar');

    function openMobileSidebar() {
      sidebarEl.classList.add('ep-sidebar--open');
      sidebarBackdrop.classList.add('ep-sidebar-backdrop--visible');
      mobileNavToggle.textContent = '✕';
    }
    function closeMobileSidebar() {
      sidebarEl.classList.remove('ep-sidebar--open');
      sidebarBackdrop.classList.remove('ep-sidebar-backdrop--visible');
      mobileNavToggle.textContent = '☰';
    }
    if (mobileNavToggle) {
      mobileNavToggle.addEventListener('click', function () {
        if (sidebarEl.classList.contains('ep-sidebar--open')) closeMobileSidebar();
        else openMobileSidebar();
      });
    }
    if (sidebarBackdrop) {
      sidebarBackdrop.addEventListener('click', closeMobileSidebar);
    }

    document.querySelectorAll('.ep-nav-item[data-nav]').forEach(function (el) {
      el.addEventListener('click', function () {
        switchView(el.getAttribute('data-nav'));
        closeMobileSidebar();
      });
    });

    function loadDashboard() {
      var ordersBody = document.getElementById('dash-orders-body');
      var ordersEmpty = document.getElementById('dash-orders-empty');
      var ordersTable = document.getElementById('dash-orders-table');
      var stockBody = document.getElementById('dash-stock-body');
      var stockEmpty = document.getElementById('dash-stock-empty');
      var stockTable = document.getElementById('dash-stock-table');

      ordersTable.style.display = 'none';
      ordersEmpty.style.display = 'block';
      ordersEmpty.textContent = 'Chargement…';
      stockTable.style.display = 'none';
      stockEmpty.style.display = 'block';
      stockEmpty.textContent = 'Chargement…';

      Promise.all([apiFetch('/api/orders?limit=20'), apiFetch('/api/inventory')]).then(function (results) {
        var orders = results[0].orders || [];
        var items = results[1].items || [];

        var toProcess = orders.filter(function (o) { return o.stage_status === 'payee' || o.stage_status === 'en_preparation'; }).length;
        var pendingPayment = orders.filter(function (o) { return o.financial_status !== 'paid'; }).length;
        var sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
        var revenue7d = orders
          .filter(function (o) { return o.financial_status === 'paid' && new Date(o.created_at).getTime() >= sevenDaysAgo; })
          .reduce(function (sum, o) { return sum + (parseFloat(o.total_price) || 0); }, 0);
        var criticalItems = items.filter(function (it) { return it.status === 'critical' || it.status === 'rupture'; });

        document.getElementById('dash-to-process').textContent = toProcess;
        document.getElementById('dash-pending-payment').textContent = pendingPayment;
        document.getElementById('dash-revenue').textContent = formatEuroSimple(revenue7d);
        document.getElementById('dash-critical').textContent = criticalItems.length;

        if (orders.length === 0) {
          ordersEmpty.textContent = 'Aucune commande pour l’instant.';
        } else {
          ordersTable.style.display = 'table';
          ordersEmpty.style.display = 'none';
          ordersBody.innerHTML = orders.slice(0, 6).map(function (o) {
            var custName = o.customer && (o.customer.first_name || o.customer.last_name)
              ? [o.customer.first_name, o.customer.last_name].filter(Boolean).join(' ')
              : (o.email || 'Client');
            return '<tr data-order-row data-order-id="' + o.id + '">' +
              '<td class="ep-order-id">' + o.name + '</td>' +
              '<td><div class="ep-cust-cell"><div class="name">' + custName + '</div><div class="email">' + (o.email || '') + '</div></div></td>' +
              '<td class="mono">' + formatDate(o.created_at) + '</td>' +
              '<td>' + o.line_item_count + ' article' + (o.line_item_count > 1 ? 's' : '') + '</td>' +
              '<td><span class="ep-status-pill ' + o.stage_status + '">' + statusLabel(o.stage_status) + '</span></td>' +
              '<td class="mono">' + o.total_price + ' €</td>' +
              '<td>→</td>' +
              '</tr>';
          }).join('');
        }

        if (criticalItems.length === 0) {
          stockEmpty.textContent = 'Aucun produit en stock critique. 🎉';
        } else {
          stockTable.style.display = 'table';
          stockEmpty.style.display = 'none';
          stockBody.innerHTML = criticalItems.slice(0, 6).map(function (it) {
            return '<tr>' +
              '<td>' + it.title + (it.product_type ? ' <span class="ep-item-set">' + it.product_type + '</span>' : '') + '</td>' +
              '<td class="mono">' + it.quantity + '</td>' +
              '<td><span class="ep-status-pill ' + it.status + '">' + STOCK_STATUS_LABELS[it.status] + '</span></td>' +
              '</tr>';
          }).join('');
        }
      }).catch(function () {
        ordersEmpty.textContent = 'Erreur de chargement — réessaie.';
        stockEmpty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('dash-orders-viewall').addEventListener('click', function () { switchView('orders'); });
    document.getElementById('dash-stock-viewall').addEventListener('click', function () { switchView('stock'); });
    document.getElementById('dash-orders-body').addEventListener('click', function (e) {
      var row = e.target.closest('[data-order-row]');
      if (row) openOrderDetail(row.getAttribute('data-order-id'));
    });

    var STATUS_LABELS = {
      payee: 'Payée',
      en_preparation: 'En préparation',
      expediee: 'Expédiée',
      livree: 'Livrée',
    };
    var STATUS_ORDER = ['payee', 'en_preparation', 'expediee', 'livree'];

    function statusLabel(status) {
      return STATUS_LABELS[status] || status;
    }

    function formatDate(iso) {
      if (!iso) return '—';
      var d = new Date(iso);
      return d.toLocaleDateString('fr-FR') + ' — ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    }

    function customerInitial(order) {
      var name = order.customer && order.customer.first_name ? order.customer.first_name : (order.customer && order.customer.email) || '?';
      return name.charAt(0).toUpperCase();
    }

    var ordersCache = [];
    var ordersFilter = 'all';

    function renderOrdersList() {
      var body = document.getElementById('orders-body');
      var empty = document.getElementById('orders-empty');
      var table = document.getElementById('orders-table');

      var orders = ordersFilter === 'box-break'
        ? ordersCache.filter(function (o) { return o.has_box_break; })
        : ordersCache;

      if (orders.length === 0) {
        table.style.display = 'none';
        empty.style.display = 'block';
        empty.textContent = ordersFilter === 'box-break' ? 'Aucune commande avec un box break.' : 'Aucune commande pour l’instant.';
        return;
      }
      table.style.display = 'table';
      empty.style.display = 'none';
      body.innerHTML = orders.map(function (o) {
        var custName = o.customer && (o.customer.first_name || o.customer.last_name)
          ? [o.customer.first_name, o.customer.last_name].filter(Boolean).join(' ')
          : (o.email || 'Client');
        return '<tr data-order-row data-order-id="' + o.id + '">' +
          '<td class="ep-order-id">' + o.name + '</td>' +
          '<td><div class="ep-cust-cell"><div class="name">' + custName + '</div><div class="email">' + (o.email || '') + '</div></div></td>' +
          '<td class="mono">' + formatDate(o.created_at) + '</td>' +
          '<td>' + o.line_item_count + ' article' + (o.line_item_count > 1 ? 's' : '') + '</td>' +
          '<td><span class="ep-status-pill ' + o.stage_status + '">' + statusLabel(o.stage_status) + '</span></td>' +
          '<td class="mono">' + o.total_price + ' €</td>' +
          '<td>→</td>' +
          '</tr>';
      }).join('');
    }

    function loadOrdersList() {
      var body = document.getElementById('orders-body');
      var empty = document.getElementById('orders-empty');
      var table = document.getElementById('orders-table');
      table.style.display = 'none';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/orders?limit=50').then(function (data) {
        ordersCache = data.orders || [];
        renderOrdersList();
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('orders-refresh').addEventListener('click', loadOrdersList);
    document.getElementById('orders-tabs').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-orders-filter]');
      if (!btn) return;
      ordersFilter = btn.getAttribute('data-orders-filter');
      document.querySelectorAll('#orders-tabs .ep-tab').forEach(function (t) { t.classList.remove('active'); });
      btn.classList.add('active');
      renderOrdersList();
    });
    document.getElementById('orders-body').addEventListener('click', function (e) {
      var row = e.target.closest('[data-order-row]');
      if (row) openOrderDetail(row.getAttribute('data-order-id'));
    });

    var currentOrderId = null;

    function renderTimeline(currentStatus) {
      var currentIndex = STATUS_ORDER.indexOf(currentStatus);
      var labels = {
        payee: 'Commande passée & payée',
        en_preparation: 'En cours de préparation',
        expediee: 'Expédiée',
        livree: 'Livrée',
      };
      var html = STATUS_ORDER.map(function (status, i) {
        var state = i < currentIndex ? 'done' : (i === currentIndex ? 'current' : 'pending');
        var dot = state === 'done' ? '✓' : (state === 'current' ? '●' : '○');
        return '<div class="ep-tl-item">' +
          '<div class="ep-tl-dot ' + state + '">' + dot + '</div>' +
          '<div><div class="ep-tl-title">' + labels[status] + '</div><div class="ep-tl-date mono">' + (state !== 'pending' ? '' : '—') + '</div></div>' +
          '</div>';
      }).join('');
      document.getElementById('order-timeline').innerHTML = html;
    }

    function renderOrderDetail(order) {
      currentOrderId = order.id;
      document.getElementById('order-detail-name').textContent = order.name;
      document.getElementById('order-detail-title').innerHTML = 'Commande ' + order.name + ' <span class="ep-status-pill ' + order.stage_status + '" id="order-status-pill">' + statusLabel(order.stage_status) + '</span>';
      document.getElementById('order-status-select').value = order.stage_status in STATUS_LABELS && order.stage_status !== 'payee' ? order.stage_status : 'en_preparation';
      document.getElementById('order-shopify-link').href = 'https://poke-n-drop.myshopify.com/admin/orders/' + order.id;

      document.getElementById('order-item-count').textContent = order.line_items.length + ' article' + (order.line_items.length > 1 ? 's' : '');
      document.getElementById('order-items').innerHTML = order.line_items.map(function (li) {
        return '<div class="ep-item-row">' +
          '<div><div class="ep-item-name">' + li.title + '</div><div class="ep-item-set">' + (li.variant_title || li.sku || '') + '</div></div>' +
          '<div class="ep-item-qty">× ' + li.quantity + '</div>' +
          '<div class="ep-item-price">' + li.price + ' €</div>' +
          '</div>';
      }).join('');
      document.getElementById('order-subtotal').textContent = order.total_price + ' €';
      document.getElementById('order-total').textContent = order.total_price + ' €';

      renderTimeline(order.stage_status);

      document.getElementById('order-note').value = order.note || '';

      var cust = order.customer;
      document.getElementById('order-cust-avatar').textContent = cust && cust.first_name ? cust.first_name.charAt(0).toUpperCase() : '?';
      document.getElementById('order-cust-name').textContent = cust ? [cust.first_name, cust.last_name].filter(Boolean).join(' ') : 'Client';
      document.getElementById('order-cust-email').textContent = (cust && cust.email) || '—';
      document.getElementById('order-cust-phone').textContent = (cust && cust.phone) || '—';

      var addr = order.shipping_address;
      document.getElementById('order-cust-address').textContent = addr
        ? [addr.address1, addr.zip + ' ' + addr.city, addr.country].filter(Boolean).join(', ')
        : 'Non renseignée';

      document.getElementById('order-payment-status').textContent = order.financial_status === 'paid' ? 'Payé' : order.financial_status;

      var lastFulfillment = order.fulfillments && order.fulfillments[order.fulfillments.length - 1];
      document.getElementById('order-tracking').textContent = lastFulfillment && lastFulfillment.tracking_number
        ? lastFulfillment.tracking_number
        : 'Sera généré à l’expédition';
    }

    function openOrderDetail(id) {
      switchView('order-detail');
      document.getElementById('order-detail-name').textContent = 'Chargement…';
      apiFetch('/api/orders/' + id).then(function (data) {
        renderOrderDetail(data.order);
      }).catch(function () {
        document.getElementById('order-detail-name').textContent = 'Erreur de chargement';
      });
    }

    document.getElementById('order-back-link').addEventListener('click', function (e) {
      e.preventDefault();
      switchView('orders');
    });

    document.getElementById('order-status-select').addEventListener('change', function () {
      var newStatus = this.value;
      if (!currentOrderId) return;
      this.disabled = true;
      apiFetch('/api/orders/' + currentOrderId + '/status', { method: 'POST', body: { status: newStatus } })
        .then(function (data) { renderOrderDetail(data.order); })
        .catch(function () { alert('Échec de la mise à jour du statut.'); })
        .finally(function () { document.getElementById('order-status-select').disabled = false; });
    });

    document.getElementById('order-note-save').addEventListener('click', function () {
      if (!currentOrderId) return;
      var btn = this;
      var note = document.getElementById('order-note').value;
      btn.disabled = true;
      btn.textContent = 'Enregistrement…';
      apiFetch('/api/orders/' + currentOrderId + '/note', { method: 'PATCH', body: { note: note } })
        .then(function () { btn.textContent = 'Enregistré ✓'; })
        .catch(function () { btn.textContent = 'Échec — réessaie'; })
        .finally(function () {
          setTimeout(function () { btn.textContent = 'Enregistrer la note'; btn.disabled = false; }, 1500);
        });
    });

    function formatEuroSimple(n) {
      var num = parseFloat(n);
      if (isNaN(num)) return '—';
      return num.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function stockBadgeInfo(qty) {
      qty = parseInt(qty, 10) || 0;
      if (qty <= 2) return { cls: 'critical', label: 'Critique' };
      if (qty <= 5) return { cls: 'low', label: 'Stock bas' };
      return { cls: 'ok', label: 'En stock' };
    }

    var ORIGIN_FLAGS = { fr: '🇫🇷', jp: '🇯🇵', cn: '🇨🇳', kr: '🇰🇷' };
    function originFlag(code) { return ORIGIN_FLAGS[code] || ''; }

    function loadProductsList() {
      var body = document.getElementById('products-body');
      var empty = document.getElementById('products-empty');
      var table = document.getElementById('products-table');
      table.style.display = 'none';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/products?limit=50').then(function (data) {
        var products = data.products || [];
        if (products.length === 0) {
          empty.textContent = 'Aucun produit trouvé.';
          return;
        }
        table.style.display = 'table';
        empty.style.display = 'none';
        body.innerHTML = products.map(function (p) {
          var badge = stockBadgeInfo(p.inventory_quantity);
          return '<tr data-product-row data-product-id="' + p.id + '">' +
            '<td>' + (originFlag(p.origin) ? originFlag(p.origin) + ' ' : '') + p.title + '</td>' +
            '<td>' + (p.product_type || '—') + '</td>' +
            '<td class="mono">' + formatEuroSimple(p.price) + '</td>' +
            '<td><span class="ep-stock-badge ' + badge.cls + '">' + p.inventory_quantity + '</span></td>' +
            '<td>' + (p.status === 'active' ? 'Actif' : 'Brouillon') + '</td>' +
            '<td>→</td>' +
            '</tr>';
        }).join('');
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('products-refresh').addEventListener('click', loadProductsList);
    document.getElementById('products-body').addEventListener('click', function (e) {
      var row = e.target.closest('[data-product-row]');
      if (row) openProductEdit(row.getAttribute('data-product-id'));
    });

    var currentProductId = null;
    var isCreatingProduct = false;
    var currentProductImages = [];

    function renderPhotoThumbs() {
      document.getElementById('pf-photo-thumbs').innerHTML = currentProductImages.map(function (img) {
        return '<div class="ep-photo-thumb" style="background-image:url(&quot;' + img.src + '&quot;)">' +
          '<button type="button" class="remove" data-remove-image="' + img.id + '">✕</button>' +
          '</div>';
      }).join('');
    }

    function setPhotoZoneEnabled(enabled) {
      document.getElementById('pf-upload-zone').classList.toggle('disabled', !enabled);
      document.getElementById('pf-photo-hint').hidden = enabled;
    }

    function uploadPhoto(file) {
      if (!currentProductId) return;
      var reader = new FileReader();
      reader.onload = function () {
        var base64 = String(reader.result).split(',')[1];
        apiFetch('/api/products/' + currentProductId + '/images', {
          method: 'POST',
          body: { attachment: base64, filename: file.name },
        }).then(function (data) {
          currentProductImages.push(data.image);
          renderPhotoThumbs();
          updateProductPreview();
        }).catch(function () {
          alert('Échec de l’envoi de la photo — réessaie.');
        });
      };
      reader.readAsDataURL(file);
    }

    document.getElementById('pf-upload-zone').addEventListener('click', function () {
      if (!currentProductId) return;
      document.getElementById('pf-photo-input').click();
    });

    document.getElementById('pf-photo-input').addEventListener('change', function (e) {
      Array.prototype.slice.call(e.target.files || []).forEach(uploadPhoto);
      e.target.value = '';
    });

    var uploadZoneEl = document.getElementById('pf-upload-zone');
    ['dragover', 'dragleave', 'drop'].forEach(function (evt) {
      uploadZoneEl.addEventListener(evt, function (e) { e.preventDefault(); e.stopPropagation(); });
    });
    uploadZoneEl.addEventListener('drop', function (e) {
      if (!currentProductId) return;
      var files = (e.dataTransfer && e.dataTransfer.files) || [];
      Array.prototype.slice.call(files).filter(function (f) { return f.type.indexOf('image/') === 0; }).forEach(uploadPhoto);
    });

    document.getElementById('pf-photo-thumbs').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove-image]');
      if (!btn || !currentProductId) return;
      var imageId = btn.getAttribute('data-remove-image');
      if (!confirm('Supprimer cette photo ?')) return;
      apiFetch('/api/products/' + currentProductId + '/images/' + imageId, { method: 'DELETE' })
        .then(function () {
          currentProductImages = currentProductImages.filter(function (img) { return String(img.id) !== imageId; });
          renderPhotoThumbs();
          updateProductPreview();
        })
        .catch(function () { alert('Échec de la suppression — réessaie.'); });
    });

    function updateProductPreview() {
      var name = document.getElementById('pf-title').value || 'Nom du produit';
      var ext = document.getElementById('pf-extension').value || '—';
      var flag = originFlag(document.getElementById('pf-origin').value);
      if (flag) ext = flag + ' ' + ext;
      var price = parseFloat(document.getElementById('pf-price').value) || 0;
      var cost = parseFloat(document.getElementById('pf-cost').value) || 0;
      var stock = parseInt(document.getElementById('pf-stock').value, 10) || 0;

      document.getElementById('pf-preview-name').textContent = name;
      document.getElementById('pf-preview-set').textContent = ext;
      document.getElementById('pf-preview-price').textContent = formatEuroSimple(price);

      var thumb = document.getElementById('pf-preview-thumb');
      thumb.style.backgroundImage = currentProductImages.length > 0 ? 'url(\'' + currentProductImages[0].src + '\')' : '';
      thumb.style.backgroundSize = 'cover';
      thumb.style.backgroundPosition = 'center';

      var marginEl = document.getElementById('pf-margin');
      if (cost > 0 && price > 0) {
        var margin = price - cost;
        var marginPct = (margin / price) * 100;
        marginEl.textContent = 'Marge : ' + formatEuroSimple(margin) + ' (' + marginPct.toFixed(0) + '%)';
      } else {
        marginEl.textContent = 'Marge : —';
      }

      var badge = stockBadgeInfo(stock);
      var badgeEl = document.getElementById('pf-stock-badge');
      badgeEl.textContent = badge.label;
      badgeEl.className = 'ep-stock-badge ' + badge.cls;
    }

    ['pf-title', 'pf-extension', 'pf-price', 'pf-cost', 'pf-stock'].forEach(function (id) {
      document.getElementById(id).addEventListener('input', updateProductPreview);
    });
    document.getElementById('pf-origin').addEventListener('change', updateProductPreview);

    function renderProductEdit(p) {
      currentProductId = p.id;
      isCreatingProduct = false;
      currentProductImages = p.images || [];
      document.getElementById('product-edit-name').textContent = p.title;
      document.getElementById('pf-title').value = p.title || '';
      document.getElementById('pf-extension').value = p.extension || '';
      document.getElementById('pf-origin').value = p.origin || '';
      document.getElementById('pf-type').value = p.product_type || '';
      document.getElementById('pf-description').value = (p.body_html || '').replace(/<[^>]+>/g, '');
      document.getElementById('pf-price').value = p.price || '';
      document.getElementById('pf-cost').value = p.cost || '';
      document.getElementById('pf-stock').value = p.inventory_quantity != null ? p.inventory_quantity : '';
      document.getElementById('pf-boxbreak').checked = !!p.box_break;
      document.getElementById('pf-nouveau').checked = !!p.nouveau;
      document.getElementById('pf-visible').checked = p.status === 'active';
      document.getElementById('pf-created').textContent = 'Créé le ' + new Date(p.created_at).toLocaleDateString('fr-FR');
      document.getElementById('pf-updated').textContent = 'Dernière modification : ' + new Date(p.updated_at).toLocaleDateString('fr-FR');
      document.getElementById('product-save').textContent = 'Enregistrer les modifications';
      document.getElementById('product-delete').hidden = false;
      renderPhotoThumbs();
      setPhotoZoneEnabled(true);
      updateProductPreview();
    }

    function openProductEdit(id) {
      switchView('product-edit');
      document.getElementById('product-edit-name').textContent = 'Chargement…';
      apiFetch('/api/products/' + id).then(function (data) {
        renderProductEdit(data.product);
      }).catch(function () {
        document.getElementById('product-edit-name').textContent = 'Erreur de chargement';
      });
    }

    function openProductCreate() {
      isCreatingProduct = true;
      currentProductId = null;
      currentProductImages = [];
      switchView('product-edit');
      document.getElementById('product-edit-name').textContent = 'Nouveau produit';
      document.getElementById('pf-title').value = '';
      document.getElementById('pf-extension').value = '';
      document.getElementById('pf-origin').value = '';
      document.getElementById('pf-type').value = '';
      document.getElementById('pf-description').value = '';
      document.getElementById('pf-price').value = '';
      document.getElementById('pf-cost').value = '';
      document.getElementById('pf-stock').value = '';
      document.getElementById('pf-boxbreak').checked = false;
      document.getElementById('pf-nouveau').checked = false;
      document.getElementById('pf-visible').checked = false;
      document.getElementById('pf-created').textContent = '—';
      document.getElementById('pf-updated').textContent = 'Pas encore enregistré';
      document.getElementById('product-save').textContent = 'Créer le produit';
      document.getElementById('product-delete').hidden = true;
      renderPhotoThumbs();
      setPhotoZoneEnabled(false);
      updateProductPreview();
    }

    document.getElementById('products-new').addEventListener('click', openProductCreate);

    document.getElementById('product-back-link').addEventListener('click', function (e) {
      e.preventDefault();
      switchView('products');
    });

    document.getElementById('product-save').addEventListener('click', function () {
      var btn = this;
      var titleInput = document.getElementById('pf-title');
      var payload = {
        title: titleInput.value,
        body_html: '<p>' + document.getElementById('pf-description').value + '</p>',
        product_type: document.getElementById('pf-type').value,
        extension: document.getElementById('pf-extension').value,
        origin: document.getElementById('pf-origin').value,
        price: document.getElementById('pf-price').value,
        cost: document.getElementById('pf-cost').value,
        stock: document.getElementById('pf-stock').value,
        box_break: document.getElementById('pf-boxbreak').checked,
        nouveau: document.getElementById('pf-nouveau').checked,
        status: document.getElementById('pf-visible').checked ? 'active' : 'draft',
      };

      if (!payload.title.trim()) {
        titleInput.style.outline = '2px solid #f87171';
        return;
      }
      titleInput.style.outline = '';

      var creating = isCreatingProduct;
      btn.disabled = true;
      btn.textContent = creating ? 'Création…' : 'Enregistrement…';

      var req = creating
        ? apiFetch('/api/products', { method: 'POST', body: payload })
        : apiFetch('/api/products/' + currentProductId, { method: 'PATCH', body: payload });

      req.then(function (data) {
        renderProductEdit(data.product);
        btn.textContent = creating ? '✓ Produit créé' : '✓ Enregistré';
      })
        .catch(function () { btn.textContent = 'Échec — réessaie'; })
        .finally(function () {
          setTimeout(function () {
            btn.textContent = isCreatingProduct ? 'Créer le produit' : 'Enregistrer les modifications';
            btn.disabled = false;
          }, 1500);
        });
    });

    document.getElementById('product-delete').addEventListener('click', function () {
      if (!currentProductId) return;
      var name = document.getElementById('product-edit-name').textContent;
      if (!confirm('Supprimer définitivement "' + name + '" ? Cette action est irréversible.')) return;

      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Suppression…';
      apiFetch('/api/products/' + currentProductId, { method: 'DELETE' })
        .then(function () {
          switchView('products');
          loadProductsList();
        })
        .catch(function () {
          btn.textContent = 'Échec — réessaie';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = 'Supprimer'; }, 1500);
        });
    });

    var STOCK_STATUS_LABELS = { ok: 'En stock', low: 'Stock bas', critical: 'Critique', rupture: 'Rupture' };
    var stockItems = [];
    var stockFilter = 'all';

    function stockBarPct(qty, threshold) {
      var max = Math.max(threshold * 3, qty, 1);
      return Math.min(100, Math.round((qty / max) * 100));
    }

    function renderStockTable() {
      var body = document.getElementById('stock-body');
      var filtered = stockFilter === 'all' ? stockItems : stockItems.filter(function (it) { return it.status === stockFilter; });

      if (filtered.length === 0) {
        body.innerHTML = '';
        document.getElementById('stock-empty').style.display = 'block';
        document.getElementById('stock-empty').textContent = 'Aucun produit dans cette catégorie.';
        document.getElementById('stock-table').style.display = 'none';
        return;
      }
      document.getElementById('stock-empty').style.display = 'none';
      document.getElementById('stock-table').style.display = 'table';

      body.innerHTML = filtered.map(function (it) {
        return '<tr data-stock-row data-product-id="' + it.id + '">' +
          '<td><div class="ep-item-name">' + it.title + '</div>' + (it.product_type ? '<div class="ep-item-set">' + it.product_type + '</div>' : '') + '</td>' +
          '<td>' +
            '<div class="ep-stock-qty-cell ' + it.status + '">' + it.quantity + '</div>' +
            '<div class="ep-stock-bar-wrap"><div class="ep-stock-bar ' + it.status + '" style="width:' + stockBarPct(it.quantity, it.threshold) + '%;"></div></div>' +
          '</td>' +
          '<td><span class="ep-status-pill ' + it.status + '">' + STOCK_STATUS_LABELS[it.status] + '</span></td>' +
          '<td><input type="number" class="ep-threshold-input" data-threshold-input min="0" value="' + it.threshold + '"></td>' +
          '<td>' +
            '<div class="ep-qty-edit">' +
              '<button type="button" data-qty-step="-1">–</button>' +
              '<input type="number" data-qty-input min="0" value="' + it.quantity + '">' +
              '<button type="button" data-qty-step="1">+</button>' +
            '</div>' +
          '</td>' +
          '</tr>';
      }).join('');
    }

    function renderStockStats() {
      var total = stockItems.length;
      var ok = stockItems.filter(function (it) { return it.status === 'ok'; }).length;
      var low = stockItems.filter(function (it) { return it.status === 'low'; }).length;
      var criticalCount = stockItems.filter(function (it) { return it.status === 'critical' || it.status === 'rupture'; }).length;

      document.getElementById('stat-total').textContent = total;
      document.getElementById('stat-ok').textContent = ok;
      document.getElementById('stat-low').textContent = low;
      document.getElementById('stat-critical').textContent = criticalCount;

      var banner = document.getElementById('stock-alert');
      if (criticalCount > 0) {
        banner.hidden = false;
        document.getElementById('stock-alert-count').textContent = criticalCount + ' produit' + (criticalCount > 1 ? 's' : '');
      } else {
        banner.hidden = true;
      }
    }

    function loadStockList() {
      var empty = document.getElementById('stock-empty');
      var table = document.getElementById('stock-table');
      table.style.display = 'none';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/inventory').then(function (data) {
        stockItems = data.items || [];
        if (stockItems.length === 0) {
          empty.textContent = 'Aucun produit trouvé.';
          return;
        }
        renderStockStats();
        renderStockTable();
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('stock-filters').addEventListener('click', function (e) {
      var tab = e.target.closest('[data-filter]');
      if (!tab) return;
      stockFilter = tab.getAttribute('data-filter');
      document.querySelectorAll('#stock-filters .ep-filter-tab').forEach(function (t) { t.classList.toggle('active', t === tab); });
      renderStockTable();
    });

    function saveStockRow(id, stock, threshold) {
      return apiFetch('/api/inventory/' + id, { method: 'PATCH', body: { stock: stock, threshold: threshold } })
        .then(function (data) {
          var idx = stockItems.findIndex(function (it) { return it.id === Number(id); });
          if (idx > -1) stockItems[idx] = data.item;
          renderStockStats();
          renderStockTable();
        });
    }

    document.getElementById('stock-body').addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-qty-step]');
      if (!stepBtn) return;
      var row = stepBtn.closest('[data-stock-row]');
      var qtyInput = row.querySelector('[data-qty-input]');
      var delta = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
      var newVal = Math.max(0, (parseInt(qtyInput.value, 10) || 0) + delta);
      qtyInput.value = newVal;
      qtyInput.dispatchEvent(new Event('change'));
    });

    document.getElementById('stock-body').addEventListener('change', function (e) {
      var row = e.target.closest('[data-stock-row]');
      if (!row) return;
      if (e.target.matches('[data-qty-input]') || e.target.matches('[data-threshold-input]')) {
        var id = row.getAttribute('data-product-id');
        var qty = parseInt(row.querySelector('[data-qty-input]').value, 10) || 0;
        var threshold = parseInt(row.querySelector('[data-threshold-input]').value, 10) || 0;
        saveStockRow(id, qty, threshold);
      }
    });

    var dropCountdownInterval = null;

    function startDropCountdown(dateStr) {
      if (dropCountdownInterval) clearInterval(dropCountdownInterval);
      var target = new Date(dateStr);

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        if (isNaN(target.getTime())) {
          ['drop-cd-days', 'drop-cd-hours', 'drop-cd-min', 'drop-cd-sec'].forEach(function (id) {
            document.getElementById(id).textContent = '--';
          });
          return;
        }
        var diff = Math.max(0, target - new Date());
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var mins = Math.floor((diff / (1000 * 60)) % 60);
        var secs = Math.floor((diff / 1000) % 60);
        document.getElementById('drop-cd-days').textContent = pad(days);
        document.getElementById('drop-cd-hours').textContent = pad(hours);
        document.getElementById('drop-cd-min').textContent = pad(mins);
        document.getElementById('drop-cd-sec').textContent = pad(secs);
      }
      tick();
      dropCountdownInterval = setInterval(tick, 1000);
    }

    function loadDropSettings() {
      apiFetch('/api/drop-settings').then(function (data) {
        var s = data.settings || {};
        document.getElementById('drop-datetime').value = s.next_drop_datetime || '';
        document.getElementById('drop-show-banner').checked = !!s.show_announcement_bar;
        document.getElementById('drop-text').value = s.announcement_text || '';
        document.getElementById('drop-link').value = s.announcement_link || '';
        startDropCountdown(s.next_drop_datetime);
        dropSelectedHandles = (s.drop_product_handles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
        loadDropProductsPicker();
      }).catch(function () {
        alert('Erreur de chargement des paramètres du drop — réessaie.');
      });
    }

    document.getElementById('drop-save').addEventListener('click', function () {
      var btn = this;
      var payload = {
        next_drop_datetime: document.getElementById('drop-datetime').value,
        show_announcement_bar: document.getElementById('drop-show-banner').checked,
        announcement_text: document.getElementById('drop-text').value,
        announcement_link: document.getElementById('drop-link').value,
        drop_product_handles: dropSelectedHandles.join(','),
      };
      btn.disabled = true;
      btn.textContent = 'Enregistrement…';
      apiFetch('/api/drop-settings', { method: 'PATCH', body: payload })
        .then(function (data) {
          var s = data.settings || {};
          startDropCountdown(s.next_drop_datetime);
          btn.textContent = '✓ Enregistré';
        })
        .catch(function () { btn.textContent = 'Échec — réessaie'; })
        .finally(function () {
          setTimeout(function () { btn.textContent = 'Enregistrer'; btn.disabled = false; }, 1500);
        });
    });

    var DROP_PRODUCTS_MAX = 4;
    var dropProductsCache = [];
    var dropSelectedHandles = [];

    function loadDropProductsPicker() {
      var empty = document.getElementById('drop-products-empty');
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';
      apiFetch('/api/products?limit=100').then(function (data) {
        dropProductsCache = data.products || [];
        empty.style.display = dropProductsCache.length ? 'none' : 'block';
        empty.textContent = 'Aucun produit trouvé.';
        renderDropProductsList('');
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    function updateDropProductsCount() {
      document.getElementById('drop-products-count').textContent = dropSelectedHandles.length + '/' + DROP_PRODUCTS_MAX + ' sélectionnés';
    }

    function renderDropProductsList(filterText) {
      var list = document.getElementById('drop-products-list');
      var q = (filterText || '').toLowerCase();
      var filtered = dropProductsCache.filter(function (p) {
        return !q || (p.title || '').toLowerCase().indexOf(q) !== -1;
      });
      updateDropProductsCount();
      list.innerHTML = filtered.map(function (p) {
        var selected = dropSelectedHandles.indexOf(p.handle) !== -1;
        var atMax = dropSelectedHandles.length >= DROP_PRODUCTS_MAX && !selected;
        return '<label class="ep-pick-row' + (selected ? ' is-selected' : '') + (atMax ? ' is-disabled' : '') + '" data-handle="' + p.handle + '">' +
          '<input type="checkbox" ' + (selected ? 'checked' : '') + (atMax ? ' disabled' : '') + '>' +
          (p.image ? '<img class="ep-pick-thumb" src="' + p.image + '" alt="">' : '<div class="ep-pick-thumb"></div>') +
          '<div class="ep-pick-info"><div class="ep-pick-title">' + (originFlag(p.origin) ? originFlag(p.origin) + ' ' : '') + p.title + '</div><div class="ep-pick-price mono">' + formatEuroSimple(p.price) + '</div></div>' +
          '</label>';
      }).join('');
    }

    document.getElementById('drop-products-search').addEventListener('input', function (e) {
      renderDropProductsList(e.target.value);
    });

    document.getElementById('drop-products-list').addEventListener('change', function (e) {
      var row = e.target.closest('[data-handle]');
      if (!row) return;
      var handle = row.getAttribute('data-handle');
      var idx = dropSelectedHandles.indexOf(handle);
      if (e.target.checked && idx === -1) {
        if (dropSelectedHandles.length >= DROP_PRODUCTS_MAX) { e.target.checked = false; return; }
        dropSelectedHandles.push(handle);
      } else if (!e.target.checked && idx !== -1) {
        dropSelectedHandles.splice(idx, 1);
      }
      renderDropProductsList(document.getElementById('drop-products-search').value);
    });

    var DISCOUNT_STATUS_INFO = {
      ACTIVE: { cls: 'disc-active', label: 'Actif' },
      EXPIRED: { cls: 'disc-expired', label: 'Expiré' },
      SCHEDULED: { cls: 'disc-scheduled', label: 'Programmé' },
    };

    function renderDiscountsTable(discounts) {
      var body = document.getElementById('discounts-body');
      var empty = document.getElementById('discounts-empty');
      var table = document.getElementById('discounts-table');

      if (discounts.length === 0) {
        body.innerHTML = '';
        empty.textContent = 'Aucun code promo pour l’instant.';
        empty.style.display = 'block';
        table.style.display = 'none';
        return;
      }
      empty.style.display = 'none';
      table.style.display = 'table';

      body.innerHTML = discounts.map(function (d) {
        var statusInfo = DISCOUNT_STATUS_INFO[d.status] || { cls: '', label: d.status };
        var usage = d.usage_count + (d.usage_limit ? ' / ' + d.usage_limit : '');
        var isActive = d.status === 'ACTIVE';
        return '<tr>' +
          '<td class="mono">' + d.code + '</td>' +
          '<td>' + d.summary + '</td>' +
          '<td class="mono">' + usage + '</td>' +
          '<td><span class="ep-status-pill ' + statusInfo.cls + '">' + statusInfo.label + '</span></td>' +
          '<td>' +
            '<button type="button" class="ep-mini-btn" data-toggle-discount="' + d.id + '" data-active="' + (!isActive) + '">' + (isActive ? 'Désactiver' : 'Activer') + '</button>' +
            '<button type="button" class="ep-mini-btn danger" data-delete-discount="' + d.id + '">Supprimer</button>' +
          '</td>' +
          '</tr>';
      }).join('');
    }

    function loadDiscounts() {
      var empty = document.getElementById('discounts-empty');
      var table = document.getElementById('discounts-table');
      table.style.display = 'none';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/discounts').then(function (data) {
        renderDiscountsTable(data.discounts || []);
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('discounts-refresh').addEventListener('click', loadDiscounts);

    document.getElementById('discount-new-toggle').addEventListener('click', function () {
      var panel = document.getElementById('discount-form-panel');
      panel.hidden = !panel.hidden;
    });

    document.getElementById('disc-type').addEventListener('change', function () {
      document.getElementById('disc-value-label').textContent = this.value === 'fixed_amount' ? 'Valeur (€)' : 'Valeur (%)';
    });

    document.getElementById('discount-create').addEventListener('click', function () {
      var btn = this;
      var codeInput = document.getElementById('disc-code');
      var valueInput = document.getElementById('disc-value');
      var payload = {
        code: codeInput.value,
        type: document.getElementById('disc-type').value,
        value: valueInput.value,
        usage_limit: document.getElementById('disc-usage-limit').value,
        once_per_customer: document.getElementById('disc-once-per-customer').checked,
      };

      if (!payload.code.trim()) {
        codeInput.style.outline = '2px solid #f87171';
        return;
      }
      codeInput.style.outline = '';
      if (!payload.value) {
        valueInput.style.outline = '2px solid #f87171';
        return;
      }
      valueInput.style.outline = '';

      btn.disabled = true;
      btn.textContent = 'Création…';
      apiFetch('/api/discounts', { method: 'POST', body: payload })
        .then(function () {
          codeInput.value = '';
          valueInput.value = '';
          document.getElementById('disc-usage-limit').value = '';
          document.getElementById('discount-form-panel').hidden = true;
          loadDiscounts();
        })
        .catch(function () { alert('Échec de la création — vérifie que le code n’existe pas déjà.'); })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = 'Créer le code';
        });
    });

    document.getElementById('discounts-body').addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-toggle-discount]');
      if (toggleBtn) {
        var id = toggleBtn.getAttribute('data-toggle-discount');
        var active = toggleBtn.getAttribute('data-active') === 'true';
        toggleBtn.disabled = true;
        apiFetch('/api/discounts/' + id + '/status', { method: 'POST', body: { active: active } })
          .then(loadDiscounts)
          .catch(function () { alert('Échec de la mise à jour du statut.'); toggleBtn.disabled = false; });
        return;
      }
      var deleteBtn = e.target.closest('[data-delete-discount]');
      if (deleteBtn) {
        if (!confirm('Supprimer ce code promo ? Cette action est irréversible.')) return;
        var delId = deleteBtn.getAttribute('data-delete-discount');
        deleteBtn.disabled = true;
        apiFetch('/api/discounts/' + delId, { method: 'DELETE' })
          .then(loadDiscounts)
          .catch(function () { alert('Échec de la suppression.'); deleteBtn.disabled = false; });
      }
    });

    function loadEmailAlerts() {
      var body = document.getElementById('email-alerts-body');
      var empty = document.getElementById('email-alerts-empty');
      var table = document.getElementById('email-alerts-table');
      table.style.display = 'none';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/drop-alert-subscribers').then(function (data) {
        var subs = data.subscribers || [];
        document.getElementById('email-alerts-count').textContent = subs.length;

        if (subs.length === 0) {
          empty.textContent = 'Aucun inscrit pour l’instant.';
          return;
        }
        table.style.display = 'table';
        empty.style.display = 'none';
        body.innerHTML = subs.map(function (s) {
          return '<tr>' +
            '<td class="mono">' + s.email + '</td>' +
            '<td>' + (s.name || '—') + '</td>' +
            '<td class="mono">' + formatDate(s.created_at) + '</td>' +
            '</tr>';
        }).join('');
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('email-alerts-refresh').addEventListener('click', loadEmailAlerts);

    function loadCustomers() {
      var body = document.getElementById('customers-body');
      var empty = document.getElementById('customers-empty');
      var table = document.getElementById('customers-table');
      table.style.display = 'none';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/customers?limit=100').then(function (data) {
        var customers = data.customers || [];
        if (customers.length === 0) {
          empty.textContent = 'Aucun client pour l’instant.';
          return;
        }
        table.style.display = 'table';
        empty.style.display = 'none';
        body.innerHTML = customers.map(function (c) {
          var location = [c.city, c.country].filter(Boolean).join(', ');
          return '<tr data-customer-row data-customer-id="' + c.id + '">' +
            '<td>' + c.name + '</td>' +
            '<td>' + (c.email || '—') + '</td>' +
            '<td class="mono">' + c.orders_count + '</td>' +
            '<td class="mono">' + formatEuroSimple(c.total_spent) + '</td>' +
            '<td>' + (location || '—') + '</td>' +
            '<td>→</td>' +
            '</tr>';
        }).join('');
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('customers-refresh').addEventListener('click', loadCustomers);
    document.getElementById('customers-body').addEventListener('click', function (e) {
      var row = e.target.closest('[data-customer-row]');
      if (row) openCustomerDetail(row.getAttribute('data-customer-id'));
    });

    function renderCustomerDetail(c) {
      document.getElementById('customer-detail-name').textContent = c.name;
      document.getElementById('customer-detail-title').textContent = c.name;
      document.getElementById('customer-avatar').textContent = c.name.charAt(0).toUpperCase();
      document.getElementById('customer-name').textContent = c.name;
      document.getElementById('customer-email').textContent = c.email || '—';
      document.getElementById('customer-phone').textContent = c.phone || '—';
      document.getElementById('customer-total-spent').textContent = formatEuroSimple(c.total_spent);
      document.getElementById('customer-tags').textContent = c.tags || '—';
      document.getElementById('customer-created').textContent = new Date(c.created_at).toLocaleDateString('fr-FR');

      var addr = c.address;
      document.getElementById('customer-address').textContent = addr
        ? [addr.address1, addr.zip + ' ' + addr.city, addr.country].filter(Boolean).join(', ')
        : 'Non renseignée';

      var notePanel = document.getElementById('customer-note-panel');
      if (c.note) {
        notePanel.hidden = false;
        document.getElementById('customer-note').textContent = c.note;
      } else {
        notePanel.hidden = true;
      }

      var ordersEl = document.getElementById('customer-orders');
      if (!c.orders || c.orders.length === 0) {
        ordersEl.innerHTML = '<div class="ep-empty">Aucune commande pour l’instant.</div>';
      } else {
        ordersEl.innerHTML = c.orders.map(function (o) {
          return '<div class="ep-item-row">' +
            '<div><div class="ep-item-name">' + o.name + '</div><div class="ep-item-set mono">' + formatDate(o.created_at) + '</div></div>' +
            '<div class="ep-item-price">' + o.total_price + ' €</div>' +
            '</div>';
        }).join('');
      }
    }

    function openCustomerDetail(id) {
      switchView('customer-detail');
      document.getElementById('customer-detail-name').textContent = 'Chargement…';
      apiFetch('/api/customers/' + id).then(function (data) {
        renderCustomerDetail(data.customer);
      }).catch(function () {
        document.getElementById('customer-detail-name').textContent = 'Erreur de chargement';
      });
    }

    document.getElementById('customer-back-link').addEventListener('click', function (e) {
      e.preventDefault();
      switchView('customers');
    });

    function renderStars(rating) {
      var rounded = Math.round(rating);
      var out = '';
      for (var i = 1; i <= 5; i++) out += i <= rounded ? '★' : '☆';
      return out;
    }

    function loadReviews() {
      var list = document.getElementById('reviews-list');
      var empty = document.getElementById('reviews-empty');
      list.innerHTML = '';
      empty.style.display = 'block';
      empty.textContent = 'Chargement…';

      apiFetch('/api/reviews').then(function (data) {
        var reviews = data.reviews || [];
        if (reviews.length === 0) {
          empty.textContent = 'Aucun avis en attente pour l’instant.';
          return;
        }
        empty.style.display = 'none';
        list.innerHTML = reviews.map(function (r) {
          return '<div class="ep-review-card">' +
            '<div class="ep-review-head">' +
              '<div class="ep-review-meta"><b>' + r.author + '</b> — <span class="product">' + r.product_title + '</span></div>' +
              '<div class="ep-review-stars">' + renderStars(r.rating) + '</div>' +
            '</div>' +
            '<p class="ep-review-text">' + r.body + '</p>' +
            '<div class="ep-review-date">' + formatDate(r.date) + '</div>' +
            '<div style="margin-top:12px;">' +
              '<button type="button" class="ep-mini-btn" data-review-action="approve" data-product-id="' + r.product_id + '" data-review-id="' + r.id + '">✓ Approuver</button>' +
              '<button type="button" class="ep-mini-btn danger" data-review-action="reject" data-product-id="' + r.product_id + '" data-review-id="' + r.id + '">✕ Rejeter</button>' +
            '</div>' +
          '</div>';
        }).join('');
      }).catch(function () {
        empty.textContent = 'Erreur de chargement — réessaie.';
      });
    }

    document.getElementById('reviews-refresh').addEventListener('click', loadReviews);

    document.getElementById('reviews-list').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-review-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-review-action');
      var payload = {
        product_id: btn.getAttribute('data-product-id'),
        review_id: btn.getAttribute('data-review-id'),
      };
      btn.disabled = true;
      apiFetch('/api/reviews/' + action, { method: 'POST', body: payload })
        .then(loadReviews)
        .catch(function () {
          alert('Échec de l’action — réessaie.');
          btn.disabled = false;
        });
    });

    var comptaLines = [];
    var comptaIdCounter = 0;

    function formatEuro(n) {
      return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function addComptaLine() {
      var refEl = document.getElementById('compta-ref');
      var qtyEl = document.getElementById('compta-qty');
      var priceEl = document.getElementById('compta-price');

      var ref = refEl.value.trim();
      var qty = parseFloat(qtyEl.value);
      var price = parseFloat(priceEl.value);

      if (!ref || !qty || qty <= 0 || isNaN(price) || price < 0) {
        refEl.style.outline = !ref ? '2px solid #f87171' : '';
        qtyEl.style.outline = (!qty || qty <= 0) ? '2px solid #f87171' : '';
        priceEl.style.outline = (isNaN(price) || price < 0) ? '2px solid #f87171' : '';
        return;
      }
      refEl.style.outline = '';
      qtyEl.style.outline = '';
      priceEl.style.outline = '';

      comptaIdCounter++;
      comptaLines.push({ id: comptaIdCounter, ref: ref, qty: qty, price: price });

      refEl.value = '';
      qtyEl.value = '';
      priceEl.value = '';
      refEl.focus();

      renderComptaLines();
    }

    function removeComptaLine(id) {
      comptaLines = comptaLines.filter(function (l) { return l.id !== id; });
      renderComptaLines();
    }

    function resetComptaLines() {
      comptaLines = [];
      renderComptaLines();
    }

    function renderComptaLines() {
      var body = document.getElementById('compta-body');
      var empty = document.getElementById('compta-empty');
      var table = document.getElementById('compta-table');

      if (comptaLines.length === 0) {
        body.innerHTML = '';
        empty.style.display = 'block';
        table.style.display = 'none';
      } else {
        empty.style.display = 'none';
        table.style.display = 'table';
        body.innerHTML = comptaLines.map(function (l) {
          return '<tr>' +
            '<td>' + l.ref + '</td>' +
            '<td class="mono">' + l.qty + '</td>' +
            '<td class="mono">' + formatEuro(l.price) + '</td>' +
            '<td class="ep-line-total">' + formatEuro(l.qty * l.price) + '</td>' +
            '<td><button type="button" class="ep-row-del" data-remove="' + l.id + '">✕</button></td>' +
            '</tr>';
        }).join('');
      }
      renderComptaTotals();
    }

    function renderComptaTotals() {
      var totalHT = comptaLines.reduce(function (sum, l) { return sum + (l.qty * l.price); }, 0);
      var tvaRate = parseFloat(document.getElementById('cs-tva-rate').value) || 0;
      var tvaAmount = totalHT * (tvaRate / 100);
      var totalTTC = totalHT + tvaAmount;

      document.getElementById('cs-lines').textContent = comptaLines.length;
      document.getElementById('cs-ht').textContent = formatEuro(totalHT);
      document.getElementById('cs-tva').textContent = formatEuro(tvaAmount);
      document.getElementById('cs-ttc').textContent = formatEuro(totalTTC);
    }

    document.getElementById('compta-add').addEventListener('click', addComptaLine);
    document.getElementById('compta-reset').addEventListener('click', resetComptaLines);
    document.getElementById('cs-tva-rate').addEventListener('change', renderComptaTotals);
    document.getElementById('compta-body').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (btn) removeComptaLine(parseInt(btn.getAttribute('data-remove'), 10));
    });

    ['compta-ref', 'compta-qty', 'compta-price'].forEach(function (id) {
      document.getElementById(id).addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); addComptaLine(); }
      });
    });

    renderComptaLines();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-manage-cookies]');
    if (!link) return;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') {
      e.preventDefault();
      cp.showPreferences();
    } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      e.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-lookup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-lookup-submit]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var orderId = document.getElementById('order-id').value.trim();
      var email = document.getElementById('order-email').value.trim();
      if (!email) {
        document.getElementById('order-email').focus();
        return;
      }
      if (orderId) {
        try { sessionStorage.setItem('pnd_order_lookup', orderId); } catch (e) {}
      }
      window.location.href = btn.dataset.loginUrl;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var field = document.getElementById('pwSparkleField');
    if (field) {
      var html = '';
      for (var i = 0; i < 8; i++) {
        var color = i % 2 === 0 ? 'purple' : 'gold';
        var left = (Math.random() * 90 + 5).toFixed(1);
        var top = (Math.random() * 90 + 5).toFixed(1);
        var size = (8 + Math.random() * 14).toFixed(0);
        var delay = (Math.random() * 3).toFixed(2);
        html += '<div class="orb ' + color + '" style="left:' + left + '%; top:' + top + '%; width:' + size + 'px; height:' + size + 'px; animation-delay:-' + delay + 's;"></div>';
      }
      field.innerHTML = html;
    }

    var block = document.querySelector('[data-drop-datetime]');
    if (!block) return;
    var target = new Date(block.dataset.dropDatetime);

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, target - new Date());
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var mins = Math.floor((diff / (1000 * 60)) % 60);
      var secs = Math.floor((diff / 1000) % 60);

      var d = block.querySelector('[data-cd-days]');
      var h = block.querySelector('[data-cd-hours]');
      var m = block.querySelector('[data-cd-min]');
      var s = block.querySelector('[data-cd-sec]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);

    var pwAlertBtn = document.getElementById('pw-alert-submit');
    if (pwAlertBtn) {
      pwAlertBtn.addEventListener('click', function () {
        var emailInput = document.getElementById('pw-alert-email');
        var email = emailInput.value.trim();
        if (!email) return;
        var btn = this;
        btn.disabled = true;
        btn.textContent = 'Envoi…';
        fetch('https://pnd-espace-pro-api.hugoa66000.workers.dev/api/public/drop-signup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email }),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            document.getElementById('pw-alert-form').hidden = true;
            var successEl = document.getElementById('pw-alert-success');
            var msg = 'Alerte activée — à très vite !';
            if (data.badge_count) {
              msg += ' 🎖️ Badge ' + data.badge_count + '/8';
              if (data.just_earned_reward) {
                msg += ' — collection complète !';
                if (data.reward_code) {
                  msg += ' Ton code (affiché une seule fois, note-le) : ' + data.reward_code;
                  try { localStorage.setItem('pnd_badge_reward', JSON.stringify({ email: email.toLowerCase(), code: data.reward_code })); } catch (e) {}
                }
              }
            }
            successEl.textContent = msg;
            successEl.hidden = false;
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Me prévenir';
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prochain-drop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var block = document.querySelector('[data-drop-datetime]');
    if (!block) return;
    var target = new Date(block.dataset.dropDatetime);

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, target - new Date());
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var mins = Math.floor((diff / (1000 * 60)) % 60);
      var secs = Math.floor((diff / 1000) % 60);

      var d = block.querySelector('[data-cd-days]');
      var h = block.querySelector('[data-cd-hours]');
      var m = block.querySelector('[data-cd-min]');
      var s = block.querySelector('[data-cd-sec]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);

    var dropAlertBtn = document.getElementById('drop-alert-submit');
    if (dropAlertBtn) {
      dropAlertBtn.addEventListener('click', function () {
        var emailInput = document.getElementById('drop-alert-email');
        var email = emailInput.value.trim();
        if (!email) return;
        var btn = this;
        btn.disabled = true;
        btn.textContent = 'Envoi…';
        fetch('https://pnd-espace-pro-api.hugoa66000.workers.dev/api/public/drop-signup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email }),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            document.getElementById('drop-alert-form').hidden = true;
            var successEl = document.getElementById('drop-alert-success');
            var msg = 'Alerte activée — à très vite !';
            if (data.badge_count) {
              msg += ' 🎖️ Badge ' + data.badge_count + '/8';
              if (data.just_earned_reward) {
                msg += ' — collection complète !';
                if (data.reward_code) {
                  msg += ' Ton code (affiché une seule fois, note-le) : <b>' + data.reward_code + '</b>.';
                  try { localStorage.setItem('pnd_badge_reward', JSON.stringify({ email: email.toLowerCase(), code: data.reward_code })); } catch (e) {}
                }
              }
              msg += ' <a href="/pages/mes-badges" style="color:var(--gold); text-decoration:underline;">Voir mes badges</a>';
            }
            successEl.innerHTML = msg;
            successEl.hidden = false;
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Activer l\'alerte';
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document.currentScript.closest('.wrap') || document;

    // Gallery thumbnails
    var mainImg = root.querySelector('[data-gallery-main-img]');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (mainImg) mainImg.src = btn.dataset.full;
      });
    });

    // Tabs
    root.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.remove('active'); });
        root.querySelectorAll('[data-tab-content]').forEach(function (c) { c.classList.remove('active'); });
        btn.classList.add('active');
        root.querySelector('[data-tab-content="' + btn.dataset.tabBtn + '"]').classList.add('active');
      });
    });
    var scrollToReviews = root.querySelector('[data-scroll-to-reviews]');
    if (scrollToReviews) {
      scrollToReviews.addEventListener('click', function () {
        root.querySelector('[data-tab-btn="reviews"]').click();
        root.querySelector('.tabs-section').scrollIntoView({ behavior: 'smooth' });
      });
    }

    // Quantity stepper
    var qtyInput = root.querySelector('[data-qty-input]');
    var quantityHidden = root.querySelector('[data-quantity-input]');
    function syncQty() {
      if (quantityHidden && qtyInput) quantityHidden.value = qtyInput.value;
    }
    var decBtn = root.querySelector('[data-qty-decrease]');
    var incBtn = root.querySelector('[data-qty-increase]');
    if (decBtn) decBtn.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      syncQty();
    });
    if (incBtn) incBtn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      syncQty();
    });
    if (qtyInput) qtyInput.addEventListener('change', syncQty);

    // Variant selection
    var variantsEl = root.querySelector('[data-product-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var optionButtons = root.querySelectorAll('[data-option-index]');
    var selected = [];
    optionButtons.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var active = group.querySelector('.opt-btn.active');
      selected[idx] = active ? active.dataset.optionValue : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }

    function moneyFormat(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : 'EUR' });
    }

    function applyVariant(variant) {
      if (!variant) return;
      var priceEl = root.querySelector('[data-variant-price]');
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);

      var idInput = root.querySelector('[data-variant-id-input]');
      if (idInput) idInput.value = variant.id;

      var addLabel = root.querySelector('[data-add-to-cart-label]');
      if (addLabel) addLabel.textContent = 'Ajouter au panier — ' + moneyFormat(variant.price);

      var stockRow = root.querySelector('[data-stock-row]');
      var stockText = root.querySelector('[data-stock-text]');
      var available = root.getElementById ? null : null;
      var blockAvailable = root.querySelector('#purchase-block-available');
      var blockOut = root.querySelector('#purchase-block-out');

      if (stockRow) stockRow.classList.remove('low', 'out');
      if (variant.available === false) {
        if (stockRow) stockRow.classList.add('out');
        if (stockText) stockText.textContent = 'Rupture de stock';
        if (blockAvailable) blockAvailable.style.display = 'none';
        if (blockOut) blockOut.style.display = 'block';
      } else {
        if (blockAvailable) blockAvailable.style.display = 'block';
        if (blockOut) blockOut.style.display = 'none';
        if (variant.inventory_management && variant.inventory_quantity <= 5) {
          if (stockRow) stockRow.classList.add('low');
        }
        if (stockText) {
          if (variant.inventory_management) {
            stockText.innerHTML = 'En stock — <b>' + variant.inventory_quantity + '</b> disponible' + (variant.inventory_quantity > 1 ? 's' : '');
          } else {
            stockText.textContent = 'En stock';
          }
        }
      }

      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2');
      }
    }

    optionButtons.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('.opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.opt-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selected[idx] = btn.dataset.optionValue;
          applyVariant(findVariant());
        });
      });
    });

    // Review form
    var starInput = root.querySelector('#review-star-input');
    if (starInput) {
      var starButtons = starInput.querySelectorAll('[data-star]');
      starButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = parseInt(btn.getAttribute('data-star'), 10);
          starInput.setAttribute('data-rating', String(value));
          starButtons.forEach(function (b) {
            var active = parseInt(b.getAttribute('data-star'), 10) <= value;
            b.classList.toggle('active', active);
            b.textContent = active ? '★' : '☆';
          });
        });
      });
    }

    var reviewForm = root.querySelector('#review-form');
    if (reviewForm) {
      reviewForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var errorEl = document.getElementById('review-form-error');
        var successEl = document.getElementById('review-form-success');
        var submitBtn = document.getElementById('review-submit-btn');
        errorEl.hidden = true;

        var author = document.getElementById('review-author').value.trim();
        var body = document.getElementById('review-body').value.trim();
        var rating = parseInt(starInput.getAttribute('data-rating'), 10) || 0;

        if (!author || !body || rating < 1) {
          errorEl.hidden = false;
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Envoi…';

        fetch('https://pnd-espace-pro-api.hugoa66000.workers.dev/api/public/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            product_id: reviewForm.getAttribute('data-product-id'),
            author: author,
            rating: rating,
            body: body,
          }),
        }).then(function (res) {
          if (!res.ok) throw new Error('failed');
          reviewForm.hidden = true;
          successEl.hidden = false;
        }).catch(function () {
          errorEl.textContent = 'Échec de l’envoi — réessaie dans un instant.';
          errorEl.hidden = false;
        }).finally(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Envoyer mon avis';
        });
      });
    }

    // Product recommendations
    var recoEl = root.querySelector('[data-product-recommendations]');
    if (recoEl && recoEl.dataset.url) {
      fetch(recoEl.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-product-recommendations]');
          if (content && content.innerHTML.trim()) {
            recoEl.innerHTML = content.innerHTML;
          }
        })
        .catch(function () {});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var copyBtns = document.querySelectorAll('[data-copy-code]');
    var codeEl = document.querySelector('[data-referral-code]');
    if (!codeEl) return;
    copyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigator.clipboard.writeText(codeEl.textContent.trim()).then(function () {
          var original = btn.textContent;
          btn.textContent = 'Copié !';
          setTimeout(function () { btn.textContent = original; }, 1500);
        });
      });
    });
    var waBtn = document.querySelector('[data-share-whatsapp]');
    if (waBtn) {
      waBtn.href = 'https://wa.me/?text=' + encodeURIComponent('Utilise mon code ' + codeEl.textContent.trim() + ' sur Poke n\'Drop pour une réduction : ' + window.location.origin);
    }
    var emailBtn = document.querySelector('[data-share-email]');
    if (emailBtn) {
      emailBtn.href = 'mailto:?subject=' + encodeURIComponent('Mon code Poke n\'Drop') + '&body=' + encodeURIComponent('Utilise mon code ' + codeEl.textContent.trim() + ' pour une réduction sur ta première commande : ' + window.location.origin);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'pnd_wishlist';

    function getItems() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function saveItems(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('pnd:wishlist-change', { detail: { items: items } }));
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function render() {
      var items = getItems();
      var grid = document.getElementById('wishlist-grid');
      var empty = document.getElementById('wishlist-empty');

      if (items.length === 0) {
        grid.style.display = 'none';
        empty.style.display = 'block';
        return;
      }
      grid.style.display = 'grid';
      empty.style.display = 'none';

      grid.innerHTML = items.map(function (item) {
        var title = escapeHtml(item.title);
        var url = item.url || '#';
        return '<div class="prod-card">' +
          '<a href="' + url + '" class="prod-thumb-link">' +
            '<div class="prod-thumb v1">' +
              (item.image ? '<img src="' + item.image + '" alt="" width="480" height="480" loading="lazy">' : '') +
            '</div>' +
          '</a>' +
          '<button class="fav-btn" type="button" data-wishlist-remove="' + item.id + '" aria-label="Retirer des favoris" aria-pressed="true">♥</button>' +
          '<div class="prod-info">' +
            '<h4><a href="' + url + '">' + title + '</a></h4>' +
            '<div class="prod-price-row">' +
              '<span class="price mono">' + (item.price || '') + '</span>' +
              '<a href="' + url + '" class="add-btn" aria-label="Voir le produit">→</a>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    document.getElementById('wishlist-grid').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-remove]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-wishlist-remove');
      saveItems(getItems().filter(function (i) { return String(i.id) !== String(id); }));
      render();
    });

    document.addEventListener('pnd:wishlist-change', render);

    function start() { render(); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
